import React from 'react'
import LogoUrl from '../../img/logo-transparent.png'
import { StyledLogo } from './styles'

const Logo = () => <StyledLogo src={LogoUrl} alt="ukrecoproect" />

export default Logo
